import type { ClassId, InventoryState, ItemTemplate } from '@shefira/shared';

import type { CssAtlas } from '../assets/dom-atlas.js';
import { itemRow, type ItemRowParts } from './bench.js';

export { formatGold, section } from './bench.js';

/** What the merchant's two sides read to draw themselves. */
export interface MerchantView {
  icons: CssAtlas | null;
  inventory: InventoryState | undefined;
  inReach: boolean;
  wearer: { level: number; classId: ClassId };
  /** Draws the window again: a stepper or a confirmation changed. */
  redraw: () => void;
}

/**
 * The row both sides share (bench.ts), marked `merchant__row`: the camp's
 * coach finds a ware by it and its `data-template`.
 */
export function merchantRow(
  template: ItemTemplate,
  icons: CssAtlas | null,
  name?: string,
): ItemRowParts {
  const parts = itemRow(template, icons, name);
  parts.row.classList.add('merchant__row');
  return parts;
}
